import React, { Fragment, useState } from 'react';
import ReactImageVideoLightbox from 'react-image-video-lightbox';

const LightboxImages = props => { 
    const [lightboxOpen, setLightBoxOpen] = useState(false);
    const [startIndex, setStartIndex] = useState(0);
    let data = [];
    const playIcon = "/ui/images/play.svg";
    data = props.media.map((mediaItem, index) => {
        let item = {};
        item.url = mediaItem.attributes.src.value;
        item.type = mediaItem.dataset.tagtype === 'img' ? 'photo' : mediaItem.dataset.tagtype;
        return item;
    })
    return !props.media || props.media.length < 1 ? (
        <Fragment />
    ) : (
        <Fragment>
            <div className="row product-images">
                <section className="small-12 large-9 columns large-order-1 logo-and-main-container">
                    {/* Stor bild  */}
                    {props.media.map((mediaItem, index) => { 
                        const mainImage = React.createElement(
                            mediaItem.dataset.tagtype,
                            Object.assign(
                                {},
                                    ...Array.from(
                                        mediaItem.attributes,
                                        ({ name, value }) => ({ [name]: value }),
                                        ),
                                    ),
                                );
                                return (
                                    <a 
                                    data-src={mainImage.props.src}
                                    itemProp="src"
                                    onClick={() => {
                                        setStartIndex(0)
                                        setLightBoxOpen(true)
                                    }}
                                    className="product-image"
                                    >  
                                        <figure
                                            key={index}
                                            className="product-detail__image-container"
                                            src={mainImage.props.src}
                                            >
                                            {mainImage}
                                        </figure>
                                    </a>
                            );
                        }
                    )}
                </section>
                {/* thumbnails */}
                <section className="small-12 large-3 columns medium-flex-dir-column">
                    <ul className="row">
                            {props.media.map((mediaItem, index) => { 
                                const thumbnails = React.createElement(
                                    mediaItem.dataset.tagtype,
                                    Object.assign(
                                        {},
                                        ...Array.from(
                                            mediaItem.attributes,
                                            ({ name, value }) => ({ [name]: value }),
                                            ),
                                        ),
                                    );
                                    return (
                                    <li className="product-detail__image-container columns large-12">
                                        <a 
                                        data-src={thumbnails.props.src}
                                        itemProp="src"
                                        onClick={() => {
                                            setStartIndex(index)
                                            setLightBoxOpen(true)
                                        }}
                                        className="product-image"
                                        >  
                                            <figure
                                                key={index}
                                                className="product-detail__image--alter"
                                                src={thumbnails.props.src}
                                            >
                                               {thumbnails}
                                                {mediaItem.dataset.tagtype === 'video' &&
                                                 <img className="play-icon" src={playIcon} alt="play icon" />  
                                                }
                                            </figure>
                                        </a>
                                    </li>
                                    );
                                }
                            )}
                    </ul>
                </section>
            </div>
            {lightboxOpen && (
                <ReactImageVideoLightbox 
                    data={data}
                    startIndex={startIndex}
                    showResourceCount={true}
                    onCloseCallback={() => setLightBoxOpen(false)}
                    onNavigationCallback={(currentIndex) =>
                    console.log(`Current index: ${currentIndex}`)
                    }
                />
            )}
        </Fragment>
    );
}
export default LightboxImages;
